import { createAction } from '@reduxjs/toolkit';
import eventProvider from '../../event/eventProvider';
enum ActionType {
  SHOW_VEHICLE_PAGE_SELECT = 'SHOW_VEHICLE_PAGE_SELECT',
  VEHICLE_EXCEPTION_INFO = 'VEHICLE_EXCEPTION_INFO',
  BASIC_INFO_VEHICLE = 'BASIC_INFO_VEHICLE',
  MONITOR_VEHICLE_BASE_INFO = 'MONITOR_VEHICLE_BASE_INFO',
  SINGLE_VEHICLE = 'SINGLE_VEHICLE',
  SINGLE_VEHICLE_TAKEOVER_ISSUE = 'SINGLE_VEHICLE_TAKEOVER_ISSUE',
  SINGLE_VEHICLE_TRAFFIC_LIGHT = 'SINGLE_VEHICLE_TRAFFIC_LIGHT',
  SINGLE_VEHICLE_SCHEDULE = 'SINGLE_VEHICLE_SCHEDULE',
  SINGLE_VEHICLE_EXCEPTION = 'SINGLE_VEHICLE_EXCEPTION',
  SINGLE_VEHICLE_OPERATION = 'SINGLE_VEHICLE_OPERATION',
  SINGLE_TAB_TYPE = 'SINGLE_TAB_TYPE',
  VEHICLE_MAP_REQUEST_SCHEDULE_POSITION = 'VEHICLE_MAP_REQUEST_SCHEDULE_POSITION',
  VEHICLE_MAP_UPDATE_SCHEDULE_POSITION = 'VEHICLE_MAP_UPDATE_SCHEDULE_POSITION',
  MERGE_BUFFER_TO_VEHICLE = 'MERGE_BUFFER_TO_VEHICLE',
  SINGLE_VEHICLE_NO_SIGNAL_INTERSECTION = 'SINGLE_VEHICLE_NO_SIGNAL_INTERSECTION',
  SINGLE_VEHICLE_ACCIDENT = 'SINGLE_VEHICLE_ACCIDENT',
  SINGLE_VEHICLE_GPS = 'SINGLE_VEHICLE_GPS',
  SINGLE_VEHICLE_ALARM = 'SINGLE_VEHICLE_ALARM',
}

export const actionSingTabType = createAction<any>(
  eventProvider.makeResponseType(ActionType.SINGLE_TAB_TYPE),
);

export default ActionType;
